<script>
  import Market from 'src/pc/pages/Market'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: Market,
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .market {
    top: 0 !important;
  }
  .market .title {
    width: 100vw;
    margin-bottom: 1.5px !important;
  }
  .market .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .market .title_top::before {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .market .title_top p {
    font-size: 34px;
  }
  .market .title_top span {
    width: 64px;
    height: 64px;
    margin-right: 0;
  }
   .market .list_insta ul {
    margin-top: 15px;
    width: calc(100vw - 30px);
    grid-template-columns: repeat(auto-fill, minmax(29vw, 1fr));
    grid-gap: 5px;
    grid-auto-rows: minmax(29vw, auto);
    grid-auto-flow: dense;
  }
  .market .list_insta ul li.ctnr {
    height: 30vw;
    min-height: unset;
  }
  .market .list_insta ul li:nth-of-type(10n+1),
  .market .list_insta ul li:nth-of-type(10n+8) {
    grid-column-end: auto;
    grid-row-end: auto;
  }
  .market .list_insta ul .ad_list a img {
    width: 300px !important;
    height: auto !important;
  }
  .market .list_insta ul li:nth-of-type(6n+1),
  .market .list_insta ul li:nth-of-type(6n+5) {
    height: auto;
    grid-column-end: span 2;
    grid-row-end: span 2;
  }
  /*.market .list_insta {
    width: 100vw;
    margin-left: -20px;
  }
  .market .list_insta ul {
    margin: 0 1px 1px 0;
    width: calc((100% - 2px) / 3);
    height: calc((100vw - 2px) / 3);
  }
  .market .list_insta ul:nth-child(6n) {
    margin-bottom: 200px;
  }
  .market .list_insta ul .ad_list {
    margin-top: -100px;
  }
  .market .list_insta ul .ad_list img {
    width: 300px !important;
    height: auto !important;
  }*/
</style>
